<app-side-menu>
  <div class="budget-detail-page">

    <div class="page-header">
      <button type="button" class="btn btn-link back-link" (click)="goBack()">
        <i class="fas fa-arrow-left me-1"></i>
        Voltar para orçamentos
      </button>
      <div class="page-header__main">
        <div>
          <h1 class="page-title">
            <i class="fas fa-file-invoice-dollar me-2"></i>
            Detalhes do Orçamento
            <span *ngIf="budget?.osNumber"> — OS {{ budget?.osNumber }}</span>
          </h1>
          <p class="page-subtitle" *ngIf="budget">
            Placa {{ budget.plateVechile || '—' }} · Status {{ budget.status || '—' }}
          </p>
        </div>
        <div class="page-header__actions">
          <button
            type="button"
            class="btn btn-outline-secondary"
            *ngIf="budget"
            (click)="imprimirOrcamento()">
            <i class="fas fa-print"></i>
            Imprimir
          </button>
          <button
            type="button"
            class="btn btn-outline-primary"
            *ngIf="canEdit"
            (click)="editBudget()">
            <i class="fas fa-pen"></i>
            Editar
          </button>
          <button
            type="button"
            class="btn btn-outline-danger"
            *ngIf="canCancelBudget"
            [disabled]="cancelling"
            (click)="cancelBudget()">
            <i class="fas fa-ban"></i>
            {{ cancelling ? 'Cancelando...' : 'Cancelar orçamento' }}
          </button>
          <button
            type="button"
            class="btn btn-warning"
            *ngIf="canRequestRevision"
            [disabled]="revising"
            (click)="requestRevision()">
            <i class="fas fa-rotate-left"></i>
            {{ revising ? 'Enviando...' : 'Solicitar Revisão' }}
          </button>
          <button
            type="button"
            class="btn btn-success"
            *ngIf="canApprove"
            [disabled]="approving"
            (click)="approveBudget()">
            <i class="fas fa-check-circle"></i>
            {{ approving ? 'Aprovando...' : 'Aprovar' }}
          </button>
          <button
            type="button"
            class="btn btn-primary"
            *ngIf="canConfirmService"
            [disabled]="confirming"
            (click)="confirmService()">
            <i class="fas fa-clipboard-check"></i>
            {{ confirming ? 'Confirmando...' : 'Confirmar Serviço' }}
          </button>
        </div>
      </div>
    </div>

    <app-loading [show]="loading" message="Carregando detalhes..."></app-loading>

    <ng-container *ngIf="!loading && budget">
      <div class="detail-card">
        <ul class="nav nav-tabs detail-tabs">
          <li class="nav-item">
            <button type="button" class="nav-link" [class.active]="detailTab === 'itens'" (click)="selectTab('itens')">
              <i class="fas fa-list-check"></i> Itens e evidências
            </button>
          </li>
          <li class="nav-item">
            <button type="button" class="nav-link" [class.active]="detailTab === 'comentarios'" (click)="selectTab('comentarios')">
              <i class="fas fa-comments"></i> Comentários
            </button>
          </li>
          <li class="nav-item">
            <button type="button" class="nav-link" [class.active]="detailTab === 'evidencias'" (click)="selectTab('evidencias')">
              <i class="fas fa-paperclip"></i> Todas evidências
            </button>
          </li>
        </ul>

        <div class="detail-card__body">
          <section class="detail-section detail-summary" *ngIf="detailTab === 'itens'">
            <h6><i class="fas fa-receipt"></i> Resumo</h6>
            <div class="detail-grid">
              <div><strong>Nº OS:</strong> {{ budget.osNumber || '—' }}</div>
              <div><strong>Placa:</strong> {{ budget.plateVechile || '—' }}</div>
              <div><strong>Status:</strong> {{ budget.status || '—' }}</div>
              <div><strong>Execução:</strong> {{ executionType === 'Base' ? 'Base' : (providerName || 'Parceiro') }}</div>
              <div *ngIf="serviceOrder?.id">
                <strong>Ordem de serviço:</strong>
                <button
                  type="button"
                  class="btn btn-link p-0 align-baseline"
                  [disabled]="mirroring"
                  (click)="openServiceOrder()">
                  #{{ serviceOrder?.id }}
                  <span *ngIf="mirroring"> (espelhando aprovado...)</span>
                </button>
              </div>
            </div>
          </section>

          <app-budget-detail-items
            *ngIf="detailTab === 'itens'"
            [budgetId]="budget.id ?? null"
            [services]="services"
            [items]="items"
            [executionType]="executionType"
            [providerName]="providerName"></app-budget-detail-items>

          <app-budget-comments
            *ngIf="detailTab === 'comentarios'"
            [budgetId]="budget.id ?? null"></app-budget-comments>

          <app-budget-evidences
            *ngIf="detailTab === 'evidencias'"
            [budgetId]="budget.id ?? null"
            [groupByLine]="true"
            [lineLabels]="services"
            [lineItems]="items"></app-budget-evidences>
        </div>
      </div>
    </ng-container>
  </div>

  <app-modal [isOpen]="showApproveRecordedAtModal"
    title="Data da aprovação do orçamento"
    [size]="'md'"
    [closable]="true"
    (close)="closeApproveRecordedAtModal()">

    <div class="py-3">
      <p class="text-muted mb-3">
        Informe quando o orçamento #{{ budget?.id }} foi aprovado. Use para lançamentos retroativos.
      </p>
      <div class="mb-3">
        <label for="approveRecordedAt" class="form-label">Data e hora <span class="text-danger">*</span></label>
        <input id="approveRecordedAt" type="datetime-local" class="form-control"
          [(ngModel)]="approveRecordedAt"
          [class.is-invalid]="!!approveRecordedAtError">
        <div class="invalid-feedback" *ngIf="approveRecordedAtError">{{ approveRecordedAtError }}</div>
      </div>
    </div>

    <div slot="footer" class="d-flex justify-content-end gap-2">
      <button type="button" class="btn btn-secondary" (click)="closeApproveRecordedAtModal()">Cancelar</button>
      <button type="button" class="btn btn-success" (click)="confirmApproveBudget()"
        [disabled]="approving || !approveRecordedAt">
        <i class="fas fa-spinner fa-spin me-1" *ngIf="approving"></i>
        Aprovar
      </button>
    </div>
  </app-modal>
</app-side-menu>
